import $ from "jquery";
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import './css/main.scss';
import QuestionBlock from "./js/QuestionBlock.js";
import SiteNavigation from "./js/SiteNavigation.js";
import CardGridCarousels from "./js/CardGridCarousels.js";
import ResponsiveTables from "./js/ResponsiveTables.js";
import redBanner from "./js/redBanner.js";

$(document).ready(function () {
    QuestionBlock();
    SiteNavigation();
    redBanner();
    CardGridCarousels();
    ResponsiveTables();
});

